import AddAdressPopup from '../popups/AddAdressPopup/AddAdressPopup';
import CancelOrderPopup from '../popups/CancelOrderPopup/CancelOrderPopup';
import CommentPopup from '../popups/CommentPopup/CommentPopup';
import DeletePopup from '../popups/DeleteAccountPopup/DeletePopup';
import ErrorOrderPopup from '../popups/ErrorOrderPopup/ErrorOrderPopup';
import ErrorPopup from '../popups/ErrorPopup/ErrorPopup';
import EditOrderPopup from '../popups/ExitOrderPopup/ExitOrderPopup';
import FailPopup from '../popups/FailPopup/FailPopup';
import HandleDeletePopup from '../popups/HandleDeletePopup/HandleDelete';
import HandleFailDelete from '../popups/HandleFailDeletePopup/HandleFailDelete';
import InvoicePopup from '../popups/InvoicePopup/InvoicePopup';
import NegativeBalancePopup from '../popups/NegativeBalancePopup/NegativeBalancePopup';
import OpenPicPopup from '../popups/OpenPicPopup/OpenPicPopup';
import OrderSuccessPopup from '../popups/OrderSuccessPopup/OrderSuccessPopup';
import OtherPaymentsPopup from '../popups/OtherPaymentsPopup/OtherPaymentsPopup';
import PaymentMethodsPopup from '../popups/PaymentMethodsPopup/PaymentMethodsPopup';
import PayMethodsLegalPopup from '../popups/PayMethodsLegalPopup/PayMethodsLegalPopup';
import SelectAddresPopup from '../popups/SelectAddresPopup/SelectAddresPopup';
import SelectStickersPopup from '../popups/SelectStickersPopup/SelectStickersPopup';
import SignAgreePopup from '../popups/SignAgreePopup/SignAgreePopup';
import SuccessMessagePopup from '../popups/SuccessMessagePopup/SuccessMessagePopup';
import SuccessPopup from '../popups/SuccessPopup/SuccessPopup';
import TopUpBalacePopup from '../popups/TopUpBalacePopup/TopUpBalacePopup';
import TopUpFailPopup from '../popups/TopUpFailPopup/TopUpFailPopup';
import TopUpSuccessPopup from '../popups/TopUpSuccessPopup/TopUpSuccessPopup';

const modalRegistry = {
  paymentMethods: PaymentMethodsPopup,
  success: SuccessPopup,
  fail: FailPopup,
  invoice: InvoicePopup,
  editOrder: EditOrderPopup,
  cancelOrder: CancelOrderPopup,
  successOrder: OrderSuccessPopup,
  errorOrder: ErrorOrderPopup,
  topUpBalance: TopUpBalacePopup,
  topUpFail: TopUpFailPopup,
  topUpSuccess: TopUpSuccessPopup,
  negativeBalance: NegativeBalancePopup,
  error: ErrorPopup,
  successMessage: SuccessMessagePopup,
  openPic: OpenPicPopup,
  comment: CommentPopup,
  SignAgree: SignAgreePopup,
  deleteAccount: DeletePopup,
  deleteAccountSuccess: HandleDeletePopup,
  deleteAccountFail: HandleFailDelete,
  otherPayments: OtherPaymentsPopup,
  addAdress: AddAdressPopup,
  selectAddres: SelectAddresPopup,
  paymentMethodsLegal: PayMethodsLegalPopup,
  selectStickers: SelectStickersPopup,
};

export default modalRegistry;
